import { AsarFormikInput } from "@/components";
import { Grid } from "@mui/material";

export default function RelationInfo() {
  return (
    <Grid
      display={"flex"}
      flexDirection={"column"}
      sx={{ width: "100%" }}
      alignItems={"center"}
      gap={"10px"}
    >
      <AsarFormikInput
        name={"nearbyName"}
        label={"نام فرد"}
        placeholder="لطفا نام فرد مورد نظر خود را بنویسید."
      />
      <AsarFormikInput
        label={"نسبت فرد"}
        name={"nearbyRel"}
        placeholder="با فرد مورد نظر چه نسبتی دارید؟"
      />
      <AsarFormikInput
        label={"تلفن همراه فرد مذکور"}
        name={"nearbyPhone"}
        type="number"
        placeholder="شماره تلفن همراه خود را وارد نمائید."
      />
    </Grid>
  );
}
